import { HelpPanel, Icon } from '@amzn/awsui-components-core';
import React from 'react';

export const AnnouncementTools: React.FC<any> = () => {
  return (
    <>
      <div></div>
    </>
  );
};
